import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { postData } from '../../../utility/Utility';
import CustomLoader from '../../../Components/CustomLoader/CustomLoader';
import { FaSearch } from 'react-icons/fa';

export default function Addip() {
    const navigate = useNavigate();
    const location = useLocation();


    const ipDataFromEdit = location.state || {};

    

    const [loading, setLoading] = useState(false);
    const [ipData, setIpData] = useState({
        ipAddress: ipDataFromEdit.ipAddress,
        title: ipDataFromEdit.title,
        description: ipDataFromEdit.description,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setIpData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await postData(`api/ip-management/${ipDataFromEdit._id ? 'update' : 'create'}`, {
                ipAddress: ipData.ipAddress,
                title: ipData.title,
                description: ipData.description,
                ...(ipDataFromEdit._id && { id: ipDataFromEdit._id }),
                ...(ipDataFromEdit._id && { status: ipDataFromEdit.status })
            });

            if (response?.success) {
                navigate('/ip-list')
            } else {
                toast.error(response?.message || 'Failed to update IP');
            }
        } catch (error) {
            toast.error(error.message || 'Error updating IP');
        } finally {
            setLoading(false);
        }
    };

    const getCurrentIP = async () => {
        try {
            // Get public IP (works in browser)
            const response = await fetch('https://api.ipify.org?format=json');
            const { ip } = await response.json();

            setIpData(prev => ({
                ...prev,
                ipAddress: ip,
                description: `Public IP: ${ip}\n\nNote: For WiFi/local network IP:\n1. Open Command Prompt\n2. Type 'ipconfig'\n3. Look for 'Wireless LAN adapter' section\n${prev.description || ''}`
            }));

            toast.success('Public IP fetched. See description for local IP instructions');
        } catch {
            toast.error('Failed to fetch IP information');
        }
    };

    return (
        <div className="content-page">
            <CustomLoader loading={loading} />
            <ToastContainer position="top-right" autoClose={5000} />
            <div className="content">
                <div className="container-fluid">
                    <div className="py-3 d-flex justify-content-between">
                        <h4 className="fs-18 fw-semibold m-0">{ipDataFromEdit._id ? 'Edit IP' : 'Add New IP'}</h4>
                        <button
                            className="btn btn-secondary"
                            onClick={() => navigate(-1)}
                            disabled={loading}
                        >
                            Back
                        </button>
                    </div>
                    <div className="breadcrumb mb-4">
                        <Link to="/home">Home</Link>
                        <span> / </span>
                        <Link to="/ip-list">IP Management</Link>
                        <span> / </span>
                        <span>{ipDataFromEdit._id ? 'Edit IP' : 'Add IP'}</span>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">IP Address*</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="ipAddress"
                                                            value={ipData.ipAddress}
                                                            onChange={handleInputChange}
                                                            required
                                                            disabled={loading}
                                                        />
                                                        <button
                                                            className="btn btn-outline-secondary"
                                                            type="button"
                                                            onClick={getCurrentIP}
                                                            disabled={loading}
                                                            title="Auto-fill current IP"
                                                        >
                                                            <FaSearch />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Title*</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="title"
                                                        value={ipData.title}
                                                        onChange={handleInputChange}
                                                        required
                                                        disabled={loading}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Description</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="description"
                                                        rows="3"
                                                        value={ipData.description}
                                                        onChange={handleInputChange}
                                                        disabled={loading}
                                                    />
                                                </div>
                                            </div>

                                            <div className="text-end mt-3">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    disabled={loading}
                                                >
                                                    {ipDataFromEdit._id ? 'Update IP' : 'Add IP'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
